import $ from 'jquery';
import './libs/jquery.sticky';
import MobileDetect from 'mobile-detect';

const app = {
    bootstrap: function () {
        this.md = new MobileDetect(window.navigator.userAgent);
        this.addPlugins();
        this.start();
        return this;
    },

    addPlugins: function () {
        return this;
    },

    start: function () {
        this.menu();
        this.external_link();
        return this;
    },

    menu() {
        const $menu = $('.mobile-menu');
        $('.__close-button').on('click', function () {
            $menu.toggleClass('is-open');
        });

        $('.__mobile-menu').on('click', function () {
            $menu.toggleClass('is-open');
        });

        $(".sticky-menu").sticky({ topSpacing: 0 });

        if (this.md.mobile()) {
            $('.site-header .sticky-menu > .__inner > .__item > a:not(.touchable)').on('click', function (e) {
                e.preventDefault();
            });
        }
    },

    external_link() {
        $('a[target="_blank"]').on('click', function (e) {
            e.preventDefault();
            show_dialog(this.href);
        })
    }
};


function show_dialog(url) {
    const $dialog = $('#dialog');
    $dialog.find('.__link').text(url).attr('href', url);
    $dialog.fadeIn();
    $dialog.find('.__close').one('click', function () {
        $dialog.fadeOut();
    });
    // setTimeout(function () {
    //     location.href = url;
    // }, 2000);
}


app.bootstrap();